// extracted by mini-css-extract-plugin
export default {"nav":"App_nav__Yz+gE","navContainer":"App_navContainer__iFlwX","experimentsLabel":"App_experimentsLabel__AV+uW","link":"App_link__kpF6Q","linkActive":"App_linkActive__VRjoO"};